import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";
import { _config } from "../common/js/constant"
import * as dd from "dingtalk-jsapi"; //钉钉
import { getUser, getToken } from '@/utils/auth';
import { requestButtomAuth } from '@/api';

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'workOrderList',
        component: () => import(`@/views/workOrderList`),
        meta: {
            title: '工单列表',
            keepAlive: true
        }
    },
    {
        path: '/workOrderAdd',
        name: 'workOrderAdd',
        component: () => import(`@/views/workOrderAdd`),
        meta: {
            title: '工单创建'
        }
    },
    {
        path: '/workOrderDetail',
        name: 'workOrderDetail',
        component: () => import(`@/views/workOrderDetail`),
        meta: {
            title: '工单详情'
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach(async (to, from, next) => {
    // next()
    //缓存
    if (to.meta.keepAlive && store.state.keepAlive.indexOf(to.name) == -1) {
        console.log([...store.state.keepAlive, ...[to.name]])
        store.commit('SET_KEEP_ALIVE', [...store.state.keepAlive, ...[to.name]])
    }
    if (to.name == 'home') {
        store.commit('SET_KEEP_ALIVE', [])
    }
    if (to.name !== 'myschedule') {
        if (dd.env.platform !== "notInDingTalk") {
            dd.ready(function () {
                dd.biz.navigation.setTitle({
                    title: to.meta.title || '供应商系统',
                    onSuccess: function (result) {
                    },
                    onFail: function (err) {
                    }
                })
            })
        }
        document.title = to.meta.title || '供应商系统'
    }
    if (store.state.token) {
        next()
    } else {
        store.dispatch('getPhone').then(res => {
            next()
        }).catch(err => {
            next(false)
        })

    }
})
export default router
